module.exports = __webpack_public_path__ + "img/img24.8eb96301.png";